import { req } from './axiosFun';

// 查询位置列表
export const listOrder=(query)=> {
  return req(
    "post",
    "/api/admin/order/list",
    query
  )
}




// WEBPACK FOOTER //
// ./src/api/order.js